// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lmVh","icon":"styles_icon__30ubE"};